import React from 'react'
import '../css/Button.css'

const Button = ({ bg = 'bg-teal', color = 'white', fill = 'white', className = '', disabled, danger, minWidth = 86, children, style, ...props }) => {
  const bgClass = danger ? 'bg-red' : disabled ? 'bg-gray-muted' : bg
  const fillClass = danger ? 'fill-white' : disabled ? 'fill-snow' : fill
  const colorClass = danger ? 'white' : disabled ? 'light-gray' : color
  const cls = `Button transition-all times-new-roman dib v-mid fw5 nowrap lh-copy bn focus-outline ${fillClass} ${bgClass} ${colorClass} ${className}`
  return (
    <button className={cls} disabled={disabled} style={{ minWidth, ...style }} {...props}>
      {children}
    </button>
  )
}

export default Button
